<template>
  <NoteList
    :list="noteList"
    :is-loading="isLoading"
    :title="$t('text.customerInfoNote')"
    :customer-id="customerId"
    :disabled="disabled"
  />
</template>

<script>
import { mapGetters } from 'vuex';
import { NOTE_LIST_REQUEST } from '@/store/actions/note';
import dataListMixin from '@/mixins/dataListMixin';
import NoteList from '@/components/note/NoteList';

export default {
  mixins: [dataListMixin],

  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    NoteList,
  },

  data() {
    return {
      storeActionListRequest: NOTE_LIST_REQUEST,
      perPage: 100,
    };
  },

  computed: {
    ...mapGetters(['noteList', 'noteListStatus']),
    isLoading() {
      return this.noteListStatus === 'loading';
    },
    customerId() {
      return parseInt(this.$route.params.customerId, 10);
    },
  },

  created() {
    this.fetchData();
  },

  methods: {
    setFilterValues(data) {
      data.filters[`filter[userId]`] = this.customerId;
    },
  },
};
</script>
